import { render } from "./intranetWechatPrescriptionPayments.vue?vue&type=template&id=2cb09e14&scoped=true"
import script from "./intranetWechatPrescriptionPayments.vue?vue&type=script&lang=js"
export * from "./intranetWechatPrescriptionPayments.vue?vue&type=script&lang=js"

import "./intranetWechatPrescriptionPayments.vue?vue&type=style&index=0&id=2cb09e14&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb09e14"]])

export default __exports__